/**
 * `/admin/groups/:id` and `/admin/groups/:id/:tab` → `/groups/:id`
 * (jorigin/brewauth#29 GB1). The old tab has no counterpart and is dropped.
 */
import { Navigate, useParams } from 'react-router';
import { groupPath } from './paths';

export default function AdminGroupRedirect() {
  const { id = '' } = useParams<{ id: string }>();
  return <Navigate to={groupPath(id)} replace />;
}
